import React from 'react';
import { Button, Dropdown, Menu, Typography, Radio } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faMoneyBillWave, faUniversity, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import ManageAddMovie from './ManageAddMovie';
import BankDetails from './BankDetails';
import RevenueDetails from './RevenueDetails';
import { COLORS, STRINGS } from './utils/Constants';
import { stringFormat, getBusinessDetailsApi, connectedAccountCreateApi, connectedAccountVerifyApi,
  dateMonthTimeString, getUploadIdApi } from './utils/ApiUtils';

const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
const { Text } = Typography;
let legalCountries = [], movieIndex = -1, connectedAccountLink = '';
let boolBankFetch = false, boolAccountVerify = false;
let menu = (
  <Menu style={{ backgroundColor: COLORS.eeeWhite }} >
    <Menu.Item key="1">
      Select Your Movie
    </Menu.Item>
  </Menu>
);

export default class ManageMovie extends React.Component {
  
  state = { radioValue: 1, movieText: 'Select Your Movie', businessObj: '', movieObj: '', isVerified: false, 
  moviesList: [], extraInfo: '' };

  componentDidMount() {
    let sessionValue = this.props.sessionValue;
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
  }
  componentDidUpdate() {
    let movies = this.props.uploadedMovies;
    let oldList = this.state.moviesList;
    console.log('movies='+(movies));
    let shouldRefresh = false;
    if(movieIndex>=0) {
      let movieObjKey = movies[movieIndex];
      if(movieObjKey&&movieObjKey.movieInfo) {
        let movieObj = movieObjKey.movieInfo;
        let movieText = movieObj&&movieObj.movie ? movieObj.movie.movieName : 'Movie'+movieIndex;
        let currentMovieName = this.state.movieText;
        if(movieText!==currentMovieName) {
          shouldRefresh = true;
        }  
      }
    }
    if(movies.length!==oldList.length) {
      shouldRefresh = true;
      movieIndex = -1;
    }
    if(!(oldList===movies)) {
      console.log('objects changed');
      this.setState({ moviesList: movies });
    }
    if(shouldRefresh) {
        let defaultKey = movieIndex>=0 ? movieIndex : movies.length-1;
        menu = (
          <Menu defaultSelectedKeys={[defaultKey]} onClick={(e)=>{ this.handleMenu(e.key) }} style={{ backgroundColor: COLORS.eeeWhite }} >
          {
            movies.map((item, index) => {
              item = item.movieInfo;
              let movieName = stringFormat(item.movie&&item.movie.movieName ? item.movie.movieName : 'Movie '+index, entities);
              return <Menu.Item key={index}>{ movieName }</Menu.Item>
            })
          }
          </Menu>
        );
        this.handleMenu(defaultKey);
        this.setState({ moviesList: movies });
    }
  }
  fetchMovieWithId = (key, uploadId) => {
    console.log('key='+key+' uploadId='+uploadId);
    this.props.showHideLoader(true);
    getUploadIdApi(this.props.sessionValue, uploadId)
    .then(response => {
      console.log('got uploads data='+JSON.stringify(response));
      if(response.ok) {
        let currentList = this.state.moviesList;
        let movieObjKey = response.info;
        currentList[key] = movieObjKey;
        if(movieObjKey) {
          let movieObj = movieObjKey.movieInfo;
          let { requestLink, contactMobileNumber, contactEmailAddress, legalEntityCountry, legalEntityName } = movieObjKey;
          let extraInfo = { requestLink: requestLink, contactMobileNumber: contactMobileNumber, contactEmailAddress: contactEmailAddress, 
            legalEntityCountry: legalEntityCountry, legalEntityName: legalEntityName };
          // console.log('news uploads list='+JSON.stringify(currentList));
          this.setState({ movieObj: movieObj, extraInfo: extraInfo, moviesList: currentList });  
          this.props.updateMovieList(currentList);
        }
        this.props.showHideLoader(false);
      } else {
        this.props.showHideLoader(false);
        alert('Failed to get movie. Please try again.');
      }
    })
    .catch((error) => {
      console.log('Error fetching uploads='+JSON.stringify(error));
      alert('Failed to get movie. Please try again.');
      this.props.showHideLoader(false);
    }); 
  }
  handleMenu = (key) => {
    let movies = this.props.uploadedMovies;
    let movieObjKey = movies[key];
    if(movieObjKey) {
      movieIndex = key;
      let movieObj = movieObjKey.movieInfo;
      let { requestLink, contactMobileNumber, contactEmailAddress, legalEntityCountry, legalEntityName } = movieObjKey;
      let extraInfo = { requestLink: requestLink, contactMobileNumber: contactMobileNumber, contactEmailAddress: contactEmailAddress, 
        legalEntityCountry: legalEntityCountry, legalEntityName: legalEntityName };
      let movieText = movieObj&&movieObj.movie ? movieObj.movie.movieName : 'Movie'+key;
      console.log('movieText='+movieText+' movieObj='+JSON.stringify(movieObj));
      this.setState({ movieText: movieText, movieObj: movieObj, extraInfo: extraInfo });
      this.fetchMovieWithId(key, movieObj.id);
      if(this.state.radioValue>1) {
        this.fetchBankDetails(movieObj);
      }
    }
  }
  connectedAccount = (sessionValue, uploadId, openUrl) => {
    console.log('sessionValue='+sessionValue+' uploadId='+uploadId);
    if(sessionValue&&uploadId) {
      connectedAccountCreateApi(sessionValue, uploadId)
      .then(response => {
        console.log('connectedAccountCreateApi data='+JSON.stringify(response));
        if(response.ok) {
          console.log('connected Account Create success link='+response.info.connectedAccountLink);
          this.setState({ isVerified: false });
          if(openUrl) {
            window.open(response.info.connectedAccountLink, "_blank");
          }
          this.props.showHideLoader(false);
        } else {
          alert('Connected account create failed');
          this.props.showHideLoader(false);
        }
      })
      .catch((error) => {
        console.log('Error connected Account Create='+JSON.stringify(error));
        this.props.showHideLoader(false);
      });
    }
  }
  onChangeRadio = e => {
    let key = e.target.value;
    console.log('radio4 checked', key);
    this.setState({ radioValue: key });
    this.fetchMovieWithId(movieIndex, this.state.movieObj.id);
    if(key>1) {
      this.fetchBankDetails(this.state.movieObj);
    }
  }
  fetchBankDetails = (movieObj) => {
    let sessionValue = this.props.sessionValue;
    this.props.showHideLoader(true);
    boolBankFetch = false; boolAccountVerify = false;
    this.accountVerifyApi(sessionValue, movieObj.id);
    getBusinessDetailsApi(sessionValue, movieObj.id)
      .then(response => {
        boolBankFetch = true;
        console.log('Business Details='+JSON.stringify(response.info));
        if(response.ok) {
          console.log('Business Details success');
          this.setState({ businessObj: response.info });
        } else {
          console.log('Business Details failed!');
          this.setState({ businessObj: '' });
        }
        if(boolBankFetch&&boolAccountVerify) {
          this.props.showHideLoader(false);
        }
      })
      .catch((error) => {
        boolBankFetch = true;
        console.log('Error getting Business Details='+JSON.stringify(error));
        this.setState({ businessObj: '' });
        if(boolBankFetch&&boolAccountVerify) {
          this.props.showHideLoader(false);
        }
      });
  }
  accountVerifyApi = (sessionValue, uploadId) => {
    connectedAccountVerifyApi(sessionValue, uploadId)
    .then(response => {
      boolAccountVerify = true;
      console.log('connectedAccountCreateApi data='+JSON.stringify(response)+' uploadId='+uploadId);
      console.log('connected Account verify success');
      if(response.ok&&response.info.status&&(response.info.status!=='false')) {
        this.setState({ isVerified: true });
        connectedAccountLink = response.info.connectedAccountLink;
      } else {
        this.setState({ isVerified: false });
      }
      if(boolBankFetch&&boolAccountVerify) {
        this.props.showHideLoader(false);
      }
    })
    .catch((error) => {
      boolAccountVerify = true;
      this.setState({ isVerified: false });
      if(boolBankFetch&&boolAccountVerify) {
        this.props.showHideLoader(false);
      }
    });
  }
  openAccountLink = (openUrl, newMovieObj) => {
    let movieObj = newMovieObj ? newMovieObj : this.state.movieObj;
    let sessionValue = this.props.sessionValue;
    let uploadId = movieObj.id;
    console.log('bank details movieObj='+JSON.stringify(movieObj));
    this.props.showHideLoader(true);
    if(this.state.isVerified) {
      console.log('connected Account verified!');
      this.props.showHideLoader(false);
      window.open(connectedAccountLink, "_blank");
    } else {
      console.log('connected Account not there');
      this.connectedAccount(sessionValue, uploadId, openUrl);  
    }
  }
  render() {
    let date = this.state.movieObj&&this.state.movieObj.movieReleaseDate ? this.state.movieObj.movieReleaseDate : '';
    let statusString = "You have not set a release date for your movie";
    if(date) {
      if(date*1000>Date.now()) {
        statusString = 'Your movie will be live on '+dateMonthTimeString(date);
      } else {
        statusString = 'Your movie is live since '+dateMonthTimeString(date);
      }
    }
    let legalCountriesArr = this.props.countriesData;
    if(legalCountriesArr) {
      legalCountries = legalCountriesArr;
    }
    let movieName = stringFormat(this.state.movieText, entities);
    let moviesArray = this.state.moviesList;
    return (
    <div>
        { moviesArray.length>0
        ?
        <div style={{ display: "flex", justifyContent:'center', alignItems: "center", height: 50, width: '100%', 
        fontSize: 14, borderRadius: 3, backgroundColor: COLORS.darkBlue }}>
          <Dropdown trigger={'click'} overlay={menu} >
                <Button className="caption" style={{ flex:1, textAlign:'left', height: 46, margin: 2, fontSize: 16, backgroundColor: COLORS.yellow, 
                color: COLORS.cccWhite, borderRadius: 2 }}>
                    <Text style={{ width: '100%', textAlign:'center', color: COLORS.darkBlue, fontFamily: 'OpenSans-Bold', fontSize: 16 }}>
                     {movieName}
                     <FontAwesomeIcon icon={faCaretDown} style={{ fontSize: 20, color: COLORS.darkBlue, marginLeft: 12, marginTop: 4 }} />
                    </Text>
                </Button>
          </Dropdown> 
        </div>
        :
        <div style={{ paddingTop: 40, width: '100%', textAlign: 'center' }}>
          <Text className="Agree" style={{ fontSize: 20, fontFamily: 'OpenSans-Bold', color: COLORS.yellow, lineHeight: 1.2 }}>
            No Movies created yet.
          </Text>
        </div>    
        }        
        { this.state.movieObj
        ?
        <div style={{ paddingTop: 40, width: '100%', textAlign: 'center' }}>
            <Text className="Agree" style={{ fontSize: 16, fontFamily: 'OpenSans-SemiBold', color: COLORS.redClose, lineHeight: 1.2 }}>
              <Text style={{ color: COLORS.redClose, fontFamily: 'OpenSans-Bold' }}>Current Status: </Text>
              {statusString}
            </Text>
        </div>
        :
        <div />        
        }
        { this.state.movieObj
        ?
        <div>
            <div style={{ display: "flex", justifyContent:'center', alignItems: "center", width: '100%', marginTop: 40, textAlign: 'center' }}>
                    <Radio.Group onChange={this.onChangeRadio} className='manageMovie' size='large' defaultValue={this.state.radioValue} buttonStyle="solid">
                        <Radio.Button className="rad1 radioNew" value={1}>
                            <FontAwesomeIcon className="rad1" icon={faPencilAlt} style={{ fontSize: 16, marginRight: 12 }} />
                            Edit Listing
                        </Radio.Button>
                        <Radio.Button className="rad3 radioNew" value={3}>
                            <FontAwesomeIcon className="rad3"  icon={faUniversity} style={{ fontSize: 16, marginRight: 12 }} />
                            Banking & KYC
                        </Radio.Button>
                        <Radio.Button className="rad2 radioNew" value={2}>
                            <FontAwesomeIcon className="rad2"  icon={faMoneyBillWave} style={{ fontSize: 16, marginRight: 12 }} />
                            Revenue & Stats
                        </Radio.Button>
                    </Radio.Group>
            </div> 
            <div>
            { this.state.radioValue===1
            ?
            <div>
              <ManageAddMovie movieObj={this.state.movieObj} generalInfoData={this.props.generalInfoData} userObject={this.props.userObject}
                extraInfo={this.state.extraInfo} countriesData={this.props.countriesData} refreshMoveList={this.props.refreshMoveList} />
            </div> 
            :
            ( this.state.radioValue===2
              ?
            <div>
              {/* <p className="Agree" style={{ marginTop: 100, fontSize: 16, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>
                {revenueText}
              </p>
              <div style={{ display: 'flex', width: '100%', justifyContent:'center' }}>
                <FontAwesomeIcon color={'#3a4a5a'} icon={faWater} style={{ fontSize: 36, margin: 48 }} />
              </div> */}
              <RevenueDetails movieObj={this.state.movieObj} extraInfo={this.state.extraInfo} businessObj={this.state.businessObj} 
              sessionValue={this.props.sessionValue}
              legalCountries={legalCountries} isVerified={this.state.isVerified} openAccountLink={() => { this.openAccountLink(true) }} />
            </div> 
            :
            <div>
              <BankDetails movieObj={this.state.movieObj} extraInfo={this.state.extraInfo} businessObj={this.state.businessObj} 
              legalCountries={legalCountries} isVerified={this.state.isVerified} openAccountLink={() => { this.openAccountLink(true) }} />
            </div> 
            )
            } 
            </div>  
            </div>
            :
            <div style={{ display: 'flex', height: '100vh' }} />
          }
                        
    </div>
  );
  }
}
